
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardStep3Component from './projectinvestmentwizard.step3.component';

const ProjectInvestmentWizardStep3PageModule = angular.module('project-investment-wizard-step-3-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('projectinvestmentwizard.agreement', {
        url: '/agreement',
        component: 'projectInvestmentWizardStep3',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('projectInvestmentWizardStep3', new ProjectInvestmentWizardStep3Component());

export default ProjectInvestmentWizardStep3PageModule;



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step3/projectinvestmentwizard.step3.module.js